import { Component } from "react";
import * as React from "react";
import { dark, primary } from "../../styles/Colors";
import { MenuItem } from "./MenuItem";

export class Navbar extends Component {
    public render() {
        return (
            <div className="top-bar" style={{ background: dark }}>
                <div className="top-bar-left">
                    <ul className="menu" style={{ background: dark }}>
                        <MenuItem color={primary} href="/home">MSL</MenuItem>
                    </ul>
                </div>
                <div className="top-bar-right">
                    <ul className="menu" style={{ background: dark }}>
                        <MenuItem color="white" href="/home">Home</MenuItem>
                        <MenuItem color="white" href="/in-action">In Action</MenuItem>
                        <MenuItem color="white" href="/order">Bestellen</MenuItem>
                        {/* <MenuItem color="white" href="#">Kontakt</MenuItem> */}
                    </ul>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/navigation/Navbar.tsx